<form [formGroup]="addDetailsForm">
	<div formArrayName="details">
		<div *ngFor="let prov of providerDetailsArr; let i = index">
			<div [formGroupName]="i">
				<div class="r-r-module pb-3">
					<div class="r-r-m-title">
						<h6>{{ speciality?.specialities[i]?.name }}</h6>
					</div>
					<div class="r-r-module-content">
						<div class="row">
							<div class="col-md-12">
								<span class="col-form-label"
									><span class="required-marker">*</span
									><span [translate]="'referral.request-referral.add-details.reason.title'"
										>Reason for request</span
									></span
								>
								<mat-form-field appearance="outline" class="full-width">
									<textarea
										matInput
										cdkTextareaAutosize
										cdkAutosizeMinRows="3"
										formControlName="reason"
										placeholder="{{ 'referral.request-referral.add-details.reason.title' | translate }}"></textarea>
									<mat-error>
										<app-error-message
											[control]="'reason'"
											[isFormArray]="true"
											[formGroup]="addDetailsForm.controls.details.controls[i]"></app-error-message>
									</mat-error>
								</mat-form-field>
							</div>
						</div>

						<div class="form-group row">
							<span class="col-sm-2 col-form-label for-radio-checkbox">
								<span class="required-marker">*</span
								><span [translate]="'referral.request-referral.add-details.provider.title'">Physician</span>
							</span>
							<div class="col-sm-10">
								<mat-radio-group formControlName="providerChoice">
									<mat-radio-button value="1" class="m-r-20"
										><span [translate]="'referral.request-referral.add-details.provider-choice.ehe-find-provider'"
											>I would like EHE to find a physician for me</span
										></mat-radio-button
									>
									<mat-radio-button value="2"
										><span [translate]="'referral.request-referral.add-details.provider-choice.provider-in-mind'"
											>I have a physician in mind</span
										></mat-radio-button
									>
									<app-error-message
										[control]="'providerChoice'"
										[isFormArray]="true"
										[formGroup]="addDetailsForm.controls.details.controls[i]"></app-error-message>
								</mat-radio-group>
							</div>
						</div>
						<div
							class="add-address-container"
							*ngIf="addDetailsForm.controls.details.controls[i].get('providerChoice').value === '2'">
							 
							<div formGroupName="provider">
								<div class="row">
									<div class="col-md-6">
										<div class="form-group row">
											<span class="col-sm-4 col-form-label"
												><span class="required-marker">*</span
												><span [translate]="'referral.request-referral.add-details.provider-details.form.first-name'"
													>First Name</span
												></span
											>
											<div class="col-sm-8">
												<mat-form-field class="full-width">
													<input
														matInput
														placeholder="{{
															'referral.request-referral.add-details.provider-details.form.first-name' | translate
														}}"
														formControlName="firstName" />
													<mat-error>
														<app-error-message
															[control]="'firstName'"
															[isFormArray]="true"
															[formGroup]="
																addDetailsForm.controls.details.controls[i].controls.provider
															"></app-error-message>
													</mat-error>
												</mat-form-field>
											</div>
										</div>

										<div class="form-group row">
											<span class="col-sm-4 col-form-label"
												><span class="required-marker">*</span
												><span [translate]="'referral.request-referral.add-details.provider-details.form.last-name'"
													>Last Name</span
												></span
											>
											<div class="col-sm-8">
												<mat-form-field class="full-width">
													<input
														matInput
														placeholder="{{
															'referral.request-referral.add-details.provider-details.form.last-name' | translate
														}}"
														formControlName="lastName" />
													<mat-error>
														<app-error-message
															[control]="'lastName'"
															[isFormArray]="true"
															[formGroup]="
																addDetailsForm.controls.details.controls[i].controls.provider
															"></app-error-message>
													</mat-error>
												</mat-form-field>
											</div>
										</div>

										<div class="form-group row">
											<span class="col-sm-4 col-form-label"
												><span class="required-marker">*</span
												><span [translate]="'referral.request-referral.add-details.provider-details.form.phone'"
													>Phone</span
												></span
											>
											<div class="col-sm-8">
												<mat-form-field class="full-width">
													<input
														matInput
														placeholder="{{
															'referral.request-referral.add-details.provider-details.form.phone' | translate
														}}"
														formControlName="phone"
														[imask]="phoneMask.iMaskArgs" />
													<mat-error>
														<app-error-message
															[control]="'phone'"
															[isFormArray]="true"
															[formGroup]="
																addDetailsForm.controls.details.controls[i].controls.provider
															"></app-error-message>
													</mat-error>
												</mat-form-field>
											</div>
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group row">
											<span class="col-sm-4 col-form-label"
												><span class="required-marker">*</span
												><span [translate]="'referral.request-referral.add-details.provider-details.form.address'"
													>Address</span
												></span
											>
											<div class="col-sm-8">
												<mat-form-field class="full-width">
													<input
														matInput
														placeholder="{{
															'referral.request-referral.add-details.provider-details.form.address' | translate
														}}"
														formControlName="address" />
													<mat-error>
														<app-error-message
															[control]="'address'"
															[isFormArray]="true"
															[formGroup]="
																addDetailsForm.controls.details.controls[i].controls.provider
															"></app-error-message>
													</mat-error>
												</mat-form-field>
											</div>
										</div>

										<div class="form-group row">
											<span class="col-sm-4 col-form-label"
												><span [translate]="'referral.request-referral.add-details.provider-details.form.address2'"
													>Address 2</span
												></span
											>
											<div class="col-sm-8">
												<mat-form-field class="full-width">
													<input
														matInput
														placeholder="{{
															'referral.request-referral.add-details.provider-details.form.address2' | translate
														}}"
														formControlName="address2" />
												</mat-form-field>
											</div>
										</div>

										<div class="form-group row">
											<span class="col-sm-4 col-form-label"
												><span [translate]="'referral.request-referral.add-details.provider-details.form.fax'"
													>Fax</span
												></span
											>
											<div class="col-sm-8">
												<mat-form-field class="full-width">
													<input
														matInput
														placeholder="{{
															'referral.request-referral.add-details.provider-details.form.fax' | translate
														}}"
														formControlName="fax" />
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-4">
										<div class="form-group row">
											<span class="col-sm-4 col-form-label"
												><span class="required-marker">*</span
												><span [translate]="'referral.request-referral.add-details.provider-details.form.city'"
													>City</span
												></span
											>
											<div class="col-sm-8">
												<mat-form-field class="full-width">
													<input
														matInput
														placeholder="{{
															'referral.request-referral.add-details.provider-details.form.city' | translate
														}}"
														formControlName="city" />
													<mat-error>
														<app-error-message
															[control]="'city'"
															[isFormArray]="true"
															[formGroup]="
																addDetailsForm.controls.details.controls[i].controls.provider
															"></app-error-message>
													</mat-error>
												</mat-form-field>
											</div>
										</div>
									</div>

									<div class="col-md-4">
										<div class="form-group row">
											<span class="col-sm-4 col-form-label"
												><span class="required-marker">*</span
												><span [translate]="'referral.request-referral.add-details.provider-details.form.state'"
													>State</span
												></span
											>
											<div class="col-sm-8">
												<mat-form-field class="full-width">
													<mat-select
														disableOptionCentering
														panelClass="custom-material-position"
														matNativeControl
														required
														placeholder="State"
														formControlName="state">
														<mat-option *ngFor="let state of states" value="state">{{ state }}</mat-option>
													</mat-select>
													<mat-error>
														<app-error-message
															[control]="'state'"
															[isFormArray]="true"
															[formGroup]="
																addDetailsForm.controls.details.controls[i].controls.provider
															"></app-error-message>
													</mat-error>
												</mat-form-field>
											</div>
										</div>
									</div>

									<div class="col-md-4">
										<div class="form-group row">
											<span class="col-sm-4 col-form-label no-wrap"
												><span class="required-marker">*</span
												><span [translate]="'referral.request-referral.add-details.provider-details.form.zip'"
													>Zip Code</span
												></span
											>
											<div class="col-sm-8">
												<mat-form-field class="full-width">
													<input
														matInput
														placeholder="{{
															'referral.request-referral.add-details.provider-details.form.zip' | translate
														}}"
														formControlName="zip"
														[imask]="zipMask.iMaskArgs" />
													<mat-error>
														<app-error-message
															[control]="'zip'"
															[isFormArray]="true"
															[formGroup]="
																addDetailsForm.controls.details.controls[i].controls.provider
															"></app-error-message>
													</mat-error>
												</mat-form-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>

<div class="row">
	<div class="col-md-12">
		<button mat-stroked-button (click)="goBack()" appEheAnalytics [data]="analyticsData" class="button">
			<span [translate]="'referral.request-referral.stepper.back-button'">Back</span>
		</button>
		<button mat-button class="button" (click)="getProviderDetails()" appEheAnalytics [data]="analyticsData">
			<span [translate]="'referral.request-referral.stepper.next-button'">Next</span>
		</button>
		<button mat-stroked-button class="button" (click)="cancel()" appEheAnalytics [data]="analyticsData">
			<span [translate]="'referral.request-referral.stepper.cancel-button'">Cancel</span>
		</button>
	</div>
</div>
